import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import t from "../lib/i18n";

/**
 * Permanent BeeNest footer used on every public + in-app surface.
 * Carries IP attribution, copyright, Privacy Policy, and Terms links.
 * Calm tone — no marketing copy, no badges, no external trackers.
 */
export const GlobalFooter = ({ compact = false }) => {
  const { language } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer
      role="contentinfo"
      className={`max-w-6xl mx-auto w-full px-6 md:px-10 text-center text-sm space-y-2 ${
        compact ? "py-5" : "py-10"
      }`}
      style={{ color: "var(--bn-text-secondary)" }}
      data-testid="global-footer"
    >
      <p>{t(language, "footer")}</p>
      <p className="text-xs opacity-80 leading-relaxed max-w-2xl mx-auto">
        © {year} BeeNest™ by IM•BEE — {t(language, "footerAttribution")}
      </p>
      <p className="text-xs flex items-center justify-center gap-3 flex-wrap pt-1">
        <Link
          to="/privacy"
          className="underline-offset-4 hover:underline"
          data-testid="footer-privacy-link"
        >
          {t(language, "footerPrivacy")}
        </Link>
        <span aria-hidden="true">·</span>
        <Link
          to="/terms"
          className="underline-offset-4 hover:underline"
          data-testid="footer-terms-link"
        >
          {t(language, "footerTerms")}
        </Link>
      </p>
    </footer>
  );
};

export default GlobalFooter;
